<mat-form-field class="minimize-height-sm">
  <input (change)="change($event)" (dateChange)="change($event)" [(ngModel)]="value" [formControl]="date" [matDatepicker]="datepicker"
         [placeholder]="placeholder" matInput [placeholder]="">
  <mat-datepicker-toggle [for]="datepicker" matPrefix></mat-datepicker-toggle>
  <mat-datepicker #datepicker></mat-datepicker>
</mat-form-field>
